
type Props = {
    name:string,
    quantity:number,
    imagePath:string,
    foodLossLimit:string
}
const FoodElement = (props: Props) =>{
    return(
        <div>
            <div>
                <li>
                    <img src={props.imagePath}/>
                    <div>{props.name}
                    <div>× {props.quantity}</div>
                        <div className='text-xs'>{props.foodLossLimit}</div>
                    </div>
                </li>
            </div>
        </div>
    )
}

export default FoodElement